import TemplateView from "../../TemplateView"

/**
 * Component's list with ability show group titles.
 * @state   items - items array
 *          groups - groups map
 */
export default class TwoLevelList extends TemplateView {
    constructor({
        additionalClass = '',
        itemToComponent = item => null,
        itemToGroupId = item => null,
        groupToComponent = group => null,
        groupComparator = (g1, g2) => 0,
        itemComparator = (i1, i2) => 0,
    }) {
        super()

        this.params = {
            additionalClass,
            groupToComponent,
            itemToComponent,
            itemToGroupId,
            groupComparator,
            itemComparator,
        }

        this.state = {
            groups: {},
            items: [],
            showGroups: false,
        }

        this.onStatePropertyDeeplyChanged('items', () => this._renderList())
    }

    templateHtml() {
        return '<div class="components_twoLevelList <%=additionalClass%>"/>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass
        }
    }

    _renderList() {
        this.$el.empty()

        let prevGroupId = null

        this.state.items.sort((i1, i2) => {
            return this.state.showGroups ? this._itemByGroupComparator(i1, i2) : this.params.itemComparator(i1, i2)
        }).forEach(item => {
            if (this.state.showGroups) {
                const currentGroupId = this.params.itemToGroupId(item)
                if (prevGroupId !== currentGroupId) {
                    prevGroupId = currentGroupId
                    this.params.groupToComponent(this.state.groups[currentGroupId]).init(this.$el)
                }
            }
            this.params.itemToComponent(item).init(this.$el)
        })
    }

    _itemByGroupComparator = (i1, i2) => {
        const item1group = this.state.groups[this.params.itemToGroupId(i1)]
        const item2group = this.state.groups[this.params.itemToGroupId(i2)]
        const compareResult = this.params.groupComparator(item1group, item2group)
        return compareResult === 0 ? this.params.itemComparator(i1, i2) : compareResult
    }

}


// WEBPACK FOOTER //
// ./web/js/components/list/TwoLevelList.js